import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "../../app/stores/store";
import DataTable from "../../app/common/DataTable";
import { t } from "i18next";
import { useParams } from "react-router-dom";

const MembershipPaymentsByYear = () => {
    const { memberStore } = useStore();
    const { id } = useParams<{ id: string }>();

    useEffect(() => {
        memberStore.loadMembershipPaymentsByYear(id!);
    }, [memberStore]);

    return (
        <DataTable
            data={memberStore.membershipPaymentsByYear}
            columns={[
                { header: t('general.year'), key: "year" },
                { header: t('general.total'), key: "totalPayments" },
            ]}

        />
    );
};

export default observer(MembershipPaymentsByYear);